"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.implementTypedPlatformFunction = implementTypedPlatformFunction;
function implementTypedPlatformFunction(functionDef, implementation) {
    return {
        [functionDef.name]: (context, params) => {
            const request = functionDef.requestSchema.parse(params);
            const response = implementation(context, request);
            return functionDef.responseSchema.parse(response);
        },
    };
}
